// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2J7hq","emails":"CreateEditClinics_emails__3asPr","emailTagLabel":"CreateEditClinics_emailTagLabel__3Elpf"};